module.exports = __webpack_public_path__ + "img/banner.2f2da5fe.jpeg";